import { gql } from '@apollo/client';

export const START_BPS_QUESTIONNAIRE = gql`
    mutation START_QUESTIONNAIRE($productID: String) {
        startOver(productGroup: $productID) {
            productGroup
            nextQuestionnaire {
                id
                metaData {
                    questionType
                    question
                    helperText
                    priority
                    nestedQuestionLinks {
                        answerId
                        linkedQuestionId
                    }
                    parentQuestion
                    validationMsg
                    pageLevelValidationMsgText
                    pageLevelValidationMsgLink
                    noneValidationMsg
                    pageLevelNoneValidationMsgText
                    pageLevelNoneValidationMsgLink
                }
                answers {
                    id
                    value
                    label
                }
            }
            selectedQuestionnaire {
                questionId
                answers {
                    id
                }
            }
            sessionId
            stage
        }
    }
`;

export const SEND_BPS_QUESTION_ANSWER = gql`
    mutation SEND_QUESTION_ANSWER(
        $productID: String
        $sessionID: String
        $customerID: String
        $selectedQuestionnaire: [SelectedQuestionnaireRQ]
    ) {
        pullQuestionnaire(
            request: {
                productGroup: $productID
                sessionId: $sessionID
                customerId: $customerID
                selectedQuestionnaire: $selectedQuestionnaire
            }
        ) {
            productGroup
            nextQuestionnaire {
                id
                metaData {
                    questionType
                    question
                    helperText
                    questionDesc
                    validationMsg
                    pageLevelValidationMsgText
                    pageLevelValidationMsgLink
                    noneValidationMsg
                    pageLevelNoneValidationMsgText
                    pageLevelNoneValidationMsgLink
                    priority
                    parentQuestion
                    nestedQuestionLinks {
                        answerId
                        linkedQuestionId
                    }
                }
                answers {
                    id
                    value
                    label
                }
            }
            selectedQuestionnaire {
                questionId
                answers {
                    id
                }
            }
            sessionId
            stage
        }
    }
`;

export const PULL_BANKER_PRODUCT_RECOMMENDATIONS = gql`
    mutation PULL_PRODUCT_RECOMMENDATIONS(
        $productID: String
        $sessionID: String
        $customerID: String
        $selectedQuestionnaire: [SelectedQuestionnaireRQ]
    ) {
        pullProductRecommendations(
            request: {
                productGroup: $productID
                sessionId: $sessionID
                customerId: $customerID
                selectedQuestionnaire: $selectedQuestionnaire
            }
        ) {
            imageId
            recommendedProducts {
                name
                productId
                productDesc
                productGroup
                productOrder
                productCategory
                sellingPoints
                pickedForYouContent
                businessSelectorLearnMoreUrl
                applyUrl
                learnMore
                imageId
            }
        }
    }
`;
export const GET_ALL_BANKER_PRODUCTS = gql`
    query GET_ALL_PRODUCTS(
        $productID: String!
        $sessionID: String
        $customerID: String
    ) {
        getAllAvailableProducts(
            productGroup: $productID
            sessionId: $sessionID
            customerId: $customerID
        ) {
            imageId
            recommendedProducts {
                name
                productId
                productDesc
                productGroup
                productOrder
                productCategory
                sellingPoints
                pickedForYouContent
                businessSelectorLearnMoreUrl
                applyUrl
                learnMore
                imageId
                allProductOrder
            }
        }
    }
`;
